import { TableRow, TableCell, Typography, Button } from '@mui/material'
import { differenceInBusinessDays } from 'date-fns'
import type { FC } from 'react'
import { Link } from 'react-router-dom'

import type { TransformedOver60HoursApplicantData } from '@/lib/apollo/query/getOver60HoursApplicants'
import { rowHeight } from '@/utils/table'

export type Props = {
  applicant: TransformedOver60HoursApplicantData
}

const Row: FC<Props> = ({ applicant }) => (
  <TableRow hover key={applicant.id} sx={{ height: rowHeight }}>
    <TableCell component="th" scope="row">
      <Typography variant="body2" noWrap>
        {applicant.fullName}
      </Typography>
    </TableCell>
    <TableCell component="th" scope="row">
      <Typography variant="body2" noWrap>
        {differenceInBusinessDays(new Date(), applicant.joinedQueueAt)}
      </Typography>
    </TableCell>
    <TableCell align="right" padding="none">
      <Button
        size="small"
        variant="text"
        component={Link}
        to={`/applicant/${applicant.id}`}
        sx={{ whitespace: 'noWrap' }}
      >
        View applicant
      </Button>
    </TableCell>
  </TableRow>
)

export default Row
